export function selectRow(id, row, actionType) {
    return {
        type: "PODCAMP_SETTINGS_EDIT_COMPONENT",
        subType: "EDIT_" + actionType + "_ROW",
        id,
        row
    }
}